export default () => {
  let allHtml = document.querySelector('html'); 

  const emptyClassFromList = (list, className) => {
    list.forEach(element => {
      element.classList.remove(className);
    });
  }

  const main_nav_first_level_menu_items = document.querySelectorAll('.Navigation--Desktop .js-first-level-menu');
  main_nav_first_level_menu_items.forEach( item => {
    item.addEventListener('click', e => {
      let anchor = e.currentTarget.querySelector('a');
      if (anchor.classList.contains('js-first-level-has-children')) {
        e.preventDefault();
      }
    })
    item.addEventListener('mouseenter', e => {
      emptyClassFromList(main_nav_first_level_menu_items, 'is-hover');
      e.currentTarget.classList.add('is-hover');
      let anchor = e.currentTarget.querySelector('a');
      
      let mobile_panel = e.currentTarget.querySelector('.MobilePanel');
      let desktop_panel = e.currentTarget.querySelector('.DesktopPanel');

      if (!(mobile_panel || desktop_panel)) {
        resetDesktopPanel()
      } else  {
        e.preventDefault();
        if (!document.body.classList.contains('is-menu-hover')) {
          document.body.classList.add('is-menu-hover');
          allHtml.style.overflow = 'hidden';
        }

        if (anchor.classList.contains('js-products')) {
          const desktop_items_panel_first = item.querySelectorAll('.Navigation--PanelCategoryMenu .Navigation__ItemWrapper');
          if (!document.body.classList.contains('is-menu-hover')) {
            document.body.classList.add('is-menu-hover');
            allHtml.style.overflow = 'hidden';
          }

          if (desktop_items_panel_first) {
            desktop_items_panel_first.forEach(element => {
              if (element.classList.contains('is-active')) {
                loadMenuProduct(element);
              }
              element.addEventListener('click', item => {
                if (item.currentTarget.querySelector('.js-desktop-panel-first')) {          
                  removeClassFromList(desktop_items_panel_first, 'is-active');
                  loadMenuProduct(item.currentTarget);
                  item.currentTarget.classList.add('is-active');
                }
              })
            })
          }
        }

        if (anchor.classList.contains('js-first-level-has-children')) {
          let sub_items = item.querySelectorAll('.Navigation--SubMenu .Navigation__ItemWrapper');
          sub_items.forEach(element => {
            if (element.classList.contains('is-active')) {
              loadSubMenuImage(element, item);
            }

            element.addEventListener('mouseenter', el => {        
                removeClassFromList(sub_items, 'is-active');
                loadSubMenuImage(el.currentTarget, item);
                el.currentTarget.classList.add('is-active');          
            })
          })
        }
      }
    })
  });

  const footer_nav_first_level_menu_items = document.querySelectorAll('.Navigation--FooterTopMenu .js-first-level-menu');
  footer_nav_first_level_menu_items.forEach( item => {
    item.addEventListener('mouseenter', e => {
      emptyClassFromList(main_nav_first_level_menu_items, 'is-hover');
      let current_hover = e.currentTarget;
      let panel_id = current_hover.querySelector('a').dataset.menuLabel;
      let wrapper_item = document.querySelector(`.Navigation--Desktop .js-first-level-menu a[data-menu-label="${panel_id}"]`).parentElement;
      let panel_to_open = document.querySelector(`.Navigation--Desktop .js-first-level-menu a[data-menu-label="${panel_id}"]`).parentElement.querySelector('.DesktopPanel');

      wrapper_item.classList.add('is-hover');

      if (!panel_to_open) {
        resetDesktopPanel()
      } else {
        if (!document.body.classList.contains('is-menu-hover')) {
          document.body.classList.add('is-menu-hover');
          allHtml.style.overflow = 'hidden';
        }


      }
    })
  })

  const footer_nav_touchable = document.querySelectorAll('.is-touchable .Navigation--FooterTopMenu .js-first-level-menu');
  if (footer_nav_touchable) {
    footer_nav_touchable.forEach(element => {      
      element.addEventListener('click', e => {
        let anchor = e.currentTarget.querySelector('a');
        removeClassFromList(mobileSubNavigation, 'is-active');
        if (anchor.classList.contains('js-products') || anchor.classList.contains('js-first-level-has-children')) {          
          e.preventDefault();
          document.querySelector('.js-hamburger').click();
          document.body.classList.add('is-mobile-panel-open');
          let mobile_sub_panel = document.querySelector('#'+anchor.dataset.menuMobileLabel);
          mobile_sub_panel.classList.add('is-active');
          mobileMainPanel.classList.add('is-hidden');
        }
      })
    });
  }

  const mobileSubNavigation = document.querySelectorAll('.js-mobile-sub-navigation');
  const mobile_first_level_menu_items = document.querySelectorAll('.Navigation--Mobile .js-mobile-first-level-menu');
  const mobileMainPanel = document.querySelector('.js-mobile-main-panel');
  if (mobile_first_level_menu_items) {
    mobile_first_level_menu_items.forEach(element => {
      element.addEventListener('click', e => {
        let anchor = e.currentTarget.querySelector('a');
        removeClassFromList(mobileSubNavigation, 'is-active');
        if (anchor.classList.contains('js-mobile-products') || e.currentTarget.classList.contains('js-mobile-first-has-children')) {          
          e.preventDefault();
          document.body.classList.add('is-mobile-panel-open');
          let mobile_sub_panel = document.querySelector('#'+anchor.dataset.menuMobileLabel);
          mobile_sub_panel.classList.add('is-active');
          mobileMainPanel.classList.add('is-hidden');
        }
      })
    });
  }

  const close_product_panel = document.querySelectorAll('.js-close-desktop-panel');
  if (close_product_panel) {
    close_product_panel.forEach(close => {      
      close.addEventListener('click', () => {
        resetDesktopPanel()
      })
    });
  }

  const close_product_nochild = document.querySelector('.js-desktop-panel-no-child');
  if (close_product_nochild) {
    close_product_nochild.addEventListener('click', e => {
      e.preventDefault();
      resetDesktopPanel();
      window.location.href = e.currentTarget.href;
    })
  }

  const menu_arrow_back = document.querySelector('.js-arrow-back');
  if (menu_arrow_back) {
    menu_arrow_back.addEventListener('click', () => {
      if (document.body.classList.contains('is-mobile-product-category-open')) {
        document.body.classList.remove('is-mobile-product-category-open');
        if (mobile_items_panel_second) {
          removeClassFromList(mobile_items_panel_second, 'is-active');
        }
      } else {
        document.body.classList.remove('is-mobile-panel-open');
      }
    })
  }

  function resetDesktopPanel() {
    main_nav_first_level_menu_items.forEach(first_level_item => {
      let anchor = first_level_item.querySelector('a');
      if (anchor.classList.contains('js-products')) {
        const desktop_items_panel_first = first_level_item.querySelectorAll('.Navigation--PanelCategoryMenu .Navigation__ItemWrapper');
        if (desktop_items_panel_first.length > 0) {          
          removeClassFromList(desktop_items_panel_first, 'is-active');
          desktop_items_panel_first[0].classList.add( 'is-active');
        }
      }
    })

    document.body.classList.remove('is-menu-hover');
    allHtml.style.overflow = 'auto';
  }

  function removeClassFromList(list, el_class) {
    list.forEach(element => {
      element.classList.remove(el_class);
    });
  }

  const mobile_items_panel_second = document.querySelectorAll('.js-mobile-panel-second');
  if (mobile_items_panel_second) {
    mobile_items_panel_second.forEach(element => {      
      element.addEventListener('click', item => {
        removeClassFromList(mobile_items_panel_second, 'is-active');
        item.currentTarget.classList.add('is-active');
        document.body.classList.add('is-mobile-product-category-open');
      })
    });
  }

  function loadMenuProduct(element) {
    if (element) {
      let productInfo = element.querySelector('.js-desktop-panel-first').dataset;
      let desktopPanelProduct = document.querySelector('.js-desktp-panel-product');
      if (desktopPanelProduct) {
        let prodImgUrl = productInfo.catProdImg;
        let prodName = productInfo.catProdName;
        let prodLink = productInfo.catProdLink;
        let prodTheme = productInfo.catProdTheme;
        // let prodCta = productInfo.catProdCta;
        // Remove all classes from desktopPanelProduct that begin with 'is-'
        let desktopPanelProductClasses = desktopPanelProduct.classList;
        desktopPanelProductClasses.forEach(className => {
          if (className.startsWith('Theme--')) {
            desktopPanelProduct.classList.remove(className);
          }
        });

        desktopPanelProduct.classList.add('Theme--'+prodTheme)
        desktopPanelProduct.querySelector('.js-desktop-panel-prod-image').src = prodImgUrl;
        desktopPanelProduct.querySelector('.js-desktop-panel-prod-name').innerText = prodName;
        desktopPanelProduct.querySelector('.js-desktop-panel-prod-cta').href = prodLink;
      }
    }
  }

  const loadSubMenuImage = (element, item) => {
    if (element) {
      let productInfo = element.querySelector('a').dataset;
      let desktopPanelProduct = item.querySelector('.js-desktp-panel-product');
      if (desktopPanelProduct) {
        let prodImgUrl = productInfo.prodImg;

        let desktopPanelProductClasses = desktopPanelProduct.classList;
        desktopPanelProductClasses.forEach(className => {
          if (className.startsWith('Theme--')) {
            desktopPanelProduct.classList.remove(className);
          }
        });

        desktopPanelProduct.querySelector('.js-desktop-panel-prod-image').src = prodImgUrl;
      }
    }
  }
}